import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "./assets/css/element-variables.scss";
import { get, post, formPost, put, remove } from "./utils/http.js";

import { getConfigKey } from "@/api/system/user";
import Vue2OrgTree from "vue2-org-tree";
import "vue2-org-tree/dist/style.css";
import db from "./utils/localstorage.js";
import "./utils/utils.js"; //工具
import "animate.css"; //动画
import VueAMap from "vue-amap"; // 高德
import "@/assets/css/ruoyi.scss"; // ruoyi css
import permission from "./directive/permission";
import './assets/IconFont//download/iconfont.css'
VueAMap.initAMapApiLoader({
	//高德地图
	key: "d5f59a5536ef668a67f92a4ed62ad773",
	plugin: ["AMap.DistrictSearch"],
	v: "1.4.4"
});

Vue.directive('fo', {
	inserted(el, binding, vnode) {
		// 聚焦元素
		el.querySelector('.el-input').focus()
	}
})
Vue.use(VueAMap);
Vue.use(Vue2OrgTree);

import statusMap from "./utils/statusMap";
import vSelect from "./components/v-select";
import FormMaking from "form-making";
import "form-making/dist/FormMaking.css";
import func from "./utils/utils.js";
import config from "./utils/config";
import Print from "vue-print-nb";
import RightToolbar from "@/components/RightToolbar";
import Pagination from "@/components/Pagination";
import FileUpload from "@/components/FileUpload";
import ImageUpload from "@/components/ImageUpload";
import Empty from './components/empty.vue'
// import { , resetForm, addDateRange, selectDictLabel, selectDictLabels, download, handleTree, onInput, isEmpty } from "@/utils/ruoyi";
import {
	resetForm,
	addDateRange,
	parseTime,
	selectDictLabel,
	selectDictLabels,
	download,
} from "@/utils/ruoyi";

import { downLoadExcel, downLoadWord } from "@/utils/download";
import "./permission";
import * as echarts from "echarts";
Vue.use(Print);
Vue.use(FormMaking);
Vue.use(permission);

Vue.use(ElementUI);
Vue.prototype.getConfigKey = getConfigKey;
Vue.prototype.download = download;

Vue.component("vSelect", vSelect);
Vue.component("RightToolbar", RightToolbar);
Vue.component("Pagination", Pagination);
Vue.component("FileUpload", FileUpload);
Vue.component("ImageUpload", ImageUpload);
Vue.component('Empty', Empty);

Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
import { getDicts } from "@/api/system/dict/data";
Vue.prototype.parseTime = parseTime;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;
Vue.config.productionTip = false;
Vue.prototype.$getForm = func.getForm;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$formPost = formPost;
Vue.prototype.$put = put;
Vue.prototype.$remove = remove;
Vue.prototype.$echarts = echarts;
Vue.prototype.download = download;
Vue.prototype.downLoadExcel = downLoadExcel;
Vue.prototype.downLoadWord = downLoadWord;

Vue.prototype.$local = db;
Vue.prototype.$map = statusMap;
Vue.prototype.$bus = { config: config, showFire: false };
Vue.prototype.$config = config;
Vue.prototype.getDicts = getDicts;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
